import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {initLanguages} from '../../shared/store/languages/languages.actions';
import {Store} from '@ngrx/store';
import {AppState} from '../../shared/store/store';
import {PublicReportsPasswordStore} from '../../shared/store/publicReports/public-reports-password.store';
import {Observable} from 'rxjs';

@Component({
  selector: 'app-public-reports-password',
  templateUrl: './public-reports-password.component.html',
  styleUrls: ['./public-reports-password.component.scss'],
  providers: [
    PublicReportsPasswordStore
  ]
})
export class PublicReportsPasswordComponent implements OnInit {
  public readonly form: FormGroup<{
    password: FormControl<string>
  }> = this._publicReportsPasswordStore.form;

  public readonly loading$: Observable<boolean> = this._publicReportsPasswordStore.loading$;
  public readonly errors$: Observable<Array<string> | null> = this._publicReportsPasswordStore.errors$;

  constructor(
    private readonly _store: Store<AppState>,
    private readonly _publicReportsPasswordStore: PublicReportsPasswordStore
  ) {}

  ngOnInit(): void {
    this._store.dispatch(initLanguages({lang: 'en'}));
  }

  public onSubmit(): void {
    this._publicReportsPasswordStore.checkPassword();
  }
}
